import ServicePageTemplate from '../ServicePageTemplate';

const ASSETS = {
  hvac: "https://static.prod-images.emergentagent.com/jobs/580a56e6-7aa2-42cb-a3cc-a9ea8b9dae1c/images/fc57f73308498e1d8160e5e6bb615ce07760500fbdee1579bd4258b4b388ee13.jpeg",
};

const AirConditioningService = () => {
  return (
    <ServicePageTemplate
      title="Air Conditioning"
      subtitle="Cooling Solutions"
      image={ASSETS.hvac}
      description="Stay comfortable during hot Minnesota summers with BNPH's air conditioning services. We install, repair, and maintain residential and commercial AC systems to keep your home or business cool and comfortable all season long."
      features={[
        'Central AC installation and repair',
        'Energy-efficient system options',
        'Regular maintenance programs',
        'Fast cooling services',
        'Indoor air quality solutions',
        'Ductwork services',
      ]}
      services={[
        'AC Installation',
        'AC Replacement',
        'AC Repair',
        'Central Air Systems',
        'Ductless Mini-Splits',
        'AC Maintenance',
        'Refrigerant Services',
        'Thermostat Installation',
        'Ductwork Repair',
        'Air Filter Services',
        'System Tune-ups',
        'Priority Services',
      ]}
      relatedServices={[
        { title: 'Boilers', link: '/services/boilers', description: 'Complete heating and cooling solutions.' },
        { title: 'Commercial', link: '/services/commercial', description: 'Commercial HVAC services.' },
        { title: 'Residential', link: '/services/residential', description: 'Home comfort services.' },
      ]}
    />
  );
};

export default AirConditioningService;
